// angular
import { NgModule, ErrorHandler, Provider } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { LocationStrategy, PathLocationStrategy } from '@angular/common';

// ngrx
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';

// import { appReducers } from '@stores/app.reducers';

// Environments
import { environment } from '@environment/environment';

// Components
import { PluginAppModule } from '@plugins/plugin-app.module';
import { LayoutModule } from '@app/components/layout/layout.module';
import { ShareModule } from '@app/components/share/share.module';
import { SectionsModule } from '@app/components/sections/sections.module';
import { AppHelpersModule } from '@app/components/helpers/helpers.module';
import { BridgesModule } from '@app/components/bridges/bridges.module';
import { AppMainComponent } from '@app/components/layout/main/main.component';
import { AppInterceptorsProvider } from './app.interceptors';

// stores
import {rootReducers, metaReducers } from './store/state/root/root.reducer';
import { rootEffects } from './store/state/root/root.effects';
import { UsersOnlineService } from './services/app/users-online.service';
import { AppCurrentSessionService } from './services/app/app-current-session.service';

// services
import { OnlineUserService } from '@core/services/online-user/online-user.service';
import { CurrentSessionService } from '@core/services/current-session/current-session.service';
import { GeneralErrorHandler } from '@core/services/general-error-handler/error-handler.service';

import { FieldFactoryLocator, fieldFactoryLocatorProvider } from '@core/custom-forms/factories/field-factory-locator';


function errorHandlerFactory(): Provider[] {
    return environment.services.sentry.enabled ? [{ provide: ErrorHandler, useClass: GeneralErrorHandler }] : [];
}

// <diego@twonas.com> 9/8/2024 see https://v16.angular.io/guide/dependency-injection-providers


@NgModule({
    imports: [
        // TwonaModule,
        BrowserModule,
        HttpClientModule,
        // MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        PluginAppModule,
        ShareModule,
        LayoutModule,
        SectionsModule,
        AppHelpersModule,
        BridgesModule,
        // stores
        StoreModule.forRoot(rootReducers, { metaReducers }),
        !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 25 , connectInZone: true}) : [],
        EffectsModule.forRoot([...rootEffects])
    ],
    providers: [
        AppInterceptorsProvider,
        {provide: OnlineUserService, useExisting: UsersOnlineService},
        {provide: CurrentSessionService, useExisting: AppCurrentSessionService},
        {provide: FieldFactoryLocator, useFactory: fieldFactoryLocatorProvider, deps: []},
        // Spread the result of the factory function to manage custom Sentry error handler
        ...errorHandlerFactory(), 
        // {provide: LocationStrategy, useClass: PathLocationStrategy},
        //{provide: Window, useValue: window}
    ],
    bootstrap: [AppMainComponent]
})
export class AppModule { }
